export const convoIntelPathResources = {
    recordings: "recordings",
    moments: "moments",
    trackers: "trackers",
    scorecards: "scorecards",
    // todo this should be a scorecards resource
    scorecardEdit: "scorecards/:templateId",
    insights: "insights",
    customAnalysis: "custom-analysis",
    observability: "observability",
    agentChats: "agent-chats",
    agentChatDetail: "agent-chats/:interactionId",
    edit: ":recordingSid",
    taskEdit: ":taskSid/:recordingSid/:contactPhone",
} as const;
